import { motion } from "framer-motion";

/**
 * Wraps a screenshot in a browser-window chrome so it feels like a product mockup
 * instead of a raw screenshot. Optional URL text + optional dot color.
 *
 * Props:
 *   src — image URL
 *   alt — alt text (required for a11y)
 *   ratio — CSS aspect-ratio (e.g. "16/10")
 *   url — URL text shown in the address bar (optional)
 *   background — Tailwind bg class or CSS color for outer padding backdrop
 *   className — additional classes for the outer wrapper
 */
const BrowserFrame = ({
  src,
  alt,
  ratio = "16/10",
  url = "verity.talview.com",
  background = "bg-gradient-to-br from-[#161616] via-[#1a1a1c] to-[#0d0d0d]",
  className = "",
  testid,
}) => {
  return (
    <motion.figure
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-10% 0px" }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      className={`relative rounded-3xl overflow-hidden border border-[color:var(--nn-border)] ${background} p-3 md:p-6 shadow-[0_30px_80px_-30px_rgba(0,0,0,0.6)] ${className}`}
      data-testid={testid}
    >
      <div className="relative rounded-xl md:rounded-2xl overflow-hidden bg-white border border-black/10 shadow-inner">
        {/* Browser titlebar */}
        <div className="flex items-center gap-3 px-4 py-2.5 bg-[#f4f4f2] border-b border-black/10">
          <div className="flex items-center gap-1.5">
            <span className="w-3 h-3 rounded-full bg-[#ff5f57]" />
            <span className="w-3 h-3 rounded-full bg-[#febc2e]" />
            <span className="w-3 h-3 rounded-full bg-[#28c840]" />
          </div>
          <div className="hidden md:flex items-center flex-1 justify-center">
            <div className="px-3 py-1 rounded-md bg-white border border-black/10 text-[10px] font-mono text-neutral-500 min-w-[220px] text-center">
              {url}
            </div>
          </div>
          <div className="w-14" />
        </div>
        {/* Screen */}
        <div className="relative bg-white" style={{ aspectRatio: ratio }}>
          <img
            src={src}
            alt={alt}
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
        </div>
      </div>
    </motion.figure>
  );
};

export default BrowserFrame;
